/**
 * @generated SignedSource<<3f9cfd8b53531d6251f568639efd37dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MobileFooterWrapper_viewer$data = {
  readonly user?: {
    readonly __typename: "User";
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"MobileFooter_viewer">;
  readonly " $fragmentType": "MobileFooterWrapper_viewer";
};
export type MobileFooterWrapper_viewer$key = {
  readonly " $data"?: MobileFooterWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"MobileFooterWrapper_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MobileFooterWrapper_viewer",
  "selections": [
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MobileFooter_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "574d588c138749b80479c7cf95e6fbaf";

export default node;
